<template>
  <div class="regist-success">
    <img src="@/assets/img/dq/reg_success.png" />
    <p>您已注册成为万达个体商户</p>
    <div class="btn" @click="goLogin">去登录</div>
  </div>
</template>

<script>
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export default {
  methods: {
    goLogin() {
      if (isWechat()) {
        this.$router.replace({ path: '/dq/login',query:{mobile:this.$route.query.mobile||''} });
      } else {
        let len = window.history.length
        window.history.back(-len)
        this.$bsUtils.nativeApi.goBack();
      }
    },
  },
  mounted(){
    localStorage.removeItem('registInfo')
  }
};
</script>

<style lang="less" scoped>
.regist-success {
  line-height: 1;
  font-family: PingFangSC-Medium, PingFang SC;
}
img {
  margin-top: 60px;
  width: 54px;
  height: 54px;
}
p {
  font-size: 21px;
  font-weight: 500;
  color: #111111;
}
.btn {
  margin-top: 60px;
  width: 232px;
  height: 44px;
  background: #FF6F00;
  border-radius: 22px;
  margin: 40px auto;
  color: #fff;
  line-height: 44px;
  font-size: 18px;
  font-weight: 500;
}
</style>